/* ================= NAV ================= */
const navLinks = [
  { label: "Store" },
  { label: "Mac" },
  { label: "iPhone" },
  { label: "Watch" },
  { label: "Vision" },
  { label: "AirPods" },
];

/* ============ 3D MODEL SAFE PARTS ============ */
/* ❗ In objects ko kabhi animate / touch nahi karna */
const noChangeParts = [
  "Object_84",
  "Object_37",
  "Object_34",
  "Object_12",
  "Object_80",
  "Object_35",
  "Object_36",
  "Object_13",
  "Object_125",
  "Object_76",
  "Object_33",
  "Object_42",
  "Object_58",
  "Object_52",
  "Object_21",
  "Object_10",
];

/* ============ PERFORMANCE IMAGES ============ */
/* ❗ p5 = CENTER HERO (always static) */
const performanceImages = [
  { id: "p1", src: "/c.png" },
  { id: "p2", src: "/f.png" },
  { id: "p3", src: "/3.jpg" },
  { id: "p4", src: "/4.jpg" },
  { id: "p5", src: "/1.png" }, // CENTER HERO
  { id: "p6", src: "/5.jpg" },
  { id: "p7", src: "/7.png" },
];

/* ============ IMAGE POSITIONS (GSAP SAFE) ============ */
/*
  RULES:
  ✔ No negative values
  ✔ No empty objects
  ✔ Center hero static
  ✔ Balanced Apple-style arc layout
*/

const performanceImgPositions = [
  /* LEFT TOP */
  {
    id: "p1",
    left: 2,
    bottom: 66,
    transform: "rotate(-7deg) scale(0.95)",
  },

  /* RIGHT TOP */
  {
    id: "p2",
    right: 2,
    bottom: 66,
    transform: "rotate(7deg) scale(0.95)",
  },

  /* RIGHT MID */
  {
    id: "p3",
    right: 0,
    bottom: 40,
    transform: "rotate(3deg) scale(0.93)",
  },

  /* RIGHT BOTTOM */
  {
    id: "p4",
    right: 0,
    bottom: 14,
    transform: "rotate(-2deg) scale(0.9)",
  },

  /* 🔒 CENTER HERO — NEVER ANIMATED */
  {
    id: "p5",
    static: true,
  },

  /* LEFT MID */
  {
    id: "p6",
    left: 0,
    bottom: 40,
    transform: "rotate(-3deg) scale(0.93)",
  },

  /* LEFT BOTTOM */
  {
    id: "p7",
    left: 0,
    bottom: 14,
    transform: "rotate(2deg) scale(0.9)",
  },
];

/* ============ FEATURES (FLOATING TEXT BOXES) ============ */
const features = [
  {
    id: 1,
    icon: "/feature-icon1.svg",
    highlight: "Email AI.",
    text:
      "Summarize and draft replies to emails instantly, so you stay on top of your inbox.",
    styles: "left-5 md:left-20 top-[20%] opacity-0 translate-y-5",
  },
  {
    id: 2,
    icon: "/feature-icon2.svg",
    highlight: "Image AI.",
    text:
      "Generate or edit images with ease. Just type what you imagine, and let AI bring it to life.",
    styles: "right-5 md:right-20 top-[30%] opacity-0 translate-y-5",
  },
  {
    id: 3,
    icon: "/feature-icon3.svg",
    highlight: "Summarize AI.",
    text:
      "Turn long articles, reports, or notes into clear, bite-sized summaries in seconds.",
    styles: "left-5 md:left-20 top-[50%] opacity-0 translate-y-5",
  },
  {
    id: 4,
    icon: "/feature-icon4.svg",
    highlight: "AirDrop.",
    text:
      "Wirelessly share photos, large files, and more between your iPhone, Mac & other devices.",
    styles: "right-5 md:right-20 top-[70%] opacity-0 translate-y-5",
  },
  {
    id: 5,
    icon: "/feature-icon5.svg",
    highlight: "Writing Tool.",
    text:
      "Write smarter and faster — blogs, essays, captions — AI helps polish every word.",
    styles: "left-5 md:left-20 top-[90%] opacity-0 translate-y-5",
  },
];

/* ============ FEATURE VIDEO SEQUENCE ============ */
const featureSequence = [
  { videoPath: "/videos/feature-1.mp4", boxClass: ".box1", delay: 1 },
  { videoPath: "/videos/feature-2.mp4", boxClass: ".box2", delay: 0 },
  { videoPath: "/videos/feature-3.mp4", boxClass: ".box3", delay: 0 },
  { videoPath: "/videos/feature-4.mp4", boxClass: ".box4", delay: 0 },
  { videoPath: "/videos/feature-5.mp4", boxClass: ".box5", delay: 0 },
];

/* ============ FOOTER ================= */
const footerLinks = [
  { label: "Privacy Policy", link: "#" },
  { label: "Terms of Use", link: "#" },
  { label: "Sales Policy", link: "#" },
  { label: "Legal", link: "#" },
  { label: "Site Map", link: "#" },
];

/* ============ EXPORTS ================= */
export {
  navLinks,
  noChangeParts,
  performanceImages,
  performanceImgPositions,
  features,
  featureSequence,
  footerLinks,
};
